module.exports = __webpack_public_path__ + "img/1729148239154-IMG_4683.jpeg.4d2c5cf8.webp";